import { headingTagsOverlap } from './heading-common';

export default function () {
  const el = document.querySelector('.event-heading-wrapper');
  if (!el) return;

  headingTagsOverlap();
}
